var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * 
 * @file Activity feed sidebar component
 * @author Box
 */

import * as React from 'react';
import debounce from 'lodash/debounce';
import noop from 'lodash/noop';
import { FormattedMessage } from 'react-intl';
import ActivityFeed from './ActivityFeed/activity-feed/ActivityFeed';
import SidebarContent from './SidebarContent';
import messages from '../messages';
import APIContext from '../APIContext';
import { getBadUserError, getBadItemError } from '../../util/error';
import { DEFAULT_COLLAB_DEBOUNCE, DEFAULT_MAX_COLLABORATORS } from '../../constants';
import API from '../../api'; // eslint-disable-line

export var activityFeedInlineError = {
    inlineError: {
        title: messages.errorOccured,
        content: messages.activityFeedItemApiError
    }
};

var ActivitySidebar = function (_React$PureComponent) {
    _inherits(ActivitySidebar, _React$PureComponent);

    function ActivitySidebar() {
        var _ref,
            _this2 = this;

        var _temp, _this, _ret;

        _classCallCheck(this, ActivitySidebar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivitySidebar.__proto__ || Object.getPrototypeOf(ActivitySidebar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.feedSuccessCallback = function () {
            _this.fetchFeedItems();
        }, _this.feedErrorCallback = function (e) {
            _this.errorCallback(e);
            _this.fetchFeedItems();
        }, _this.deleteTask = function (_ref2) {
            var id = _ref2.id;
            var _this$props = _this.props,
                file = _this$props.file,
                api = _this$props.api,
                _this$props$onTaskDel = _this$props.onTaskDelete,
                onTaskDelete = _this$props$onTaskDel === undefined ? noop : _this$props$onTaskDel;

            api.getFeedAPI(false).deleteTask(file, id, function (taskId) {
                _this.feedSuccessCallback();
                onTaskDelete(taskId);
            }, _this.feedErrorCallback);

            // need to load the pending item
            _this.fetchFeedItems();
        }, _this.updateTask = function (_ref3) {
            var text = _ref3.text,
                id = _ref3.id;
            var _this$props2 = _this.props,
                file = _this$props2.file,
                api = _this$props2.api;

            api.getFeedAPI(false).updateTask(file, id, text, _this.feedSuccessCallback, _this.feedErrorCallback);

            // need to load the pending item
            _this.fetchFeedItems();
        }, _this.updateTaskAssignment = function (taskId, taskAssignmentId, status, message) {
            var _this$props3 = _this.props,
                file = _this$props3.file,
                api = _this$props3.api;


            api.getFeedAPI(false).updateTaskAssignment(file, taskId, taskAssignmentId, status, message, _this.feedSuccessCallback, _this.feedErrorCallback);

            // need to load the pending item
            _this.fetchFeedItems();
        }, _this.deleteComment = function (_ref4) {
            var id = _ref4.id,
                permissions = _ref4.permissions;
            var _this$props4 = _this.props,
                file = _this$props4.file,
                api = _this$props4.api,
                _this$props4$onCommen = _this$props4.onCommentDelete,
                onCommentDelete = _this$props4$onCommen === undefined ? noop : _this$props4$onCommen;


            api.getFeedAPI(false).deleteComment(file, id, permissions, function (comment) {
                _this.feedSuccessCallback();
                onCommentDelete(comment);
            }, _this.feedErrorCallback);

            // need to load the pending item
            _this.fetchFeedItems();
        }, _this.createComment = function (text, hasMention) {
            var _this$props5 = _this.props,
                file = _this$props5.file,
                api = _this$props5.api,
                _this$props5$onCommen = _this$props5.onCommentCreate,
                onCommentCreate = _this$props5$onCommen === undefined ? noop : _this$props5$onCommen;
            var currentUser = _this.state.currentUser;


            if (!currentUser) {
                throw getBadUserError();
            }

            api.getFeedAPI(false).createComment(file, currentUser, text, hasMention, function (comment) {
                onCommentCreate(comment);
                _this.feedSuccessCallback();
            }, _this.feedErrorCallback);

            // need to load the pending item
            _this.fetchFeedItems();
        }, _this.createTask = function (message, assignees, dueAt) {
            var currentUser = _this.state.currentUser;
            var _this$props6 = _this.props,
                file = _this$props6.file,
                api = _this$props6.api;


            if (!currentUser) {
                throw getBadUserError();
            }

            api.getFeedAPI(false).createTask(file, currentUser, message, assignees, dueAt, _this.feedSuccessCallback, _this.feedErrorCallback);

            // need to load the pending item
            _this.fetchFeedItems();
        }, _this.fetchFeedItemsSuccessCallback = function (feedItems) {
            _this.setState({ feedItems: feedItems, activityFeedError: undefined });
        }, _this.fetchFeedItemsErrorCallback = function (feedItems) {
            _this.setState({
                feedItems: feedItems,
                activityFeedError: activityFeedInlineError
            });
        }, _this.errorCallback = function (error) {
            /* eslint-disable no-console */
            console.error(error);
            /* eslint-enable no-console */
        }, _this.fetchCurrentUserSuccessCallback = function (currentUser) {
            _this.setState({ currentUser: currentUser, currentUserError: undefined });
        }, _this.getApproverContactsSuccessCallback = function (collaborators) {
            var entries = collaborators.entries;

            _this.setState({ approverSelectorContacts: entries });
        }, _this.getMentionContactsSuccessCallback = function (collaborators) {
            var entries = collaborators.entries;

            _this.setState({ mentionSelectorContacts: entries });
        }, _this.getApproverWithQuery = debounce(function (searchStr) {
            // Do not fetch without filter
            var _this$props7 = _this.props,
                file = _this$props7.file,
                api = _this$props7.api;

            if (!searchStr || searchStr.trim() === '') {
                return;
            }

            api.getFileCollaboratorsAPI(true).markerGet({
                id: file.id,
                limit: DEFAULT_MAX_COLLABORATORS,
                params: {
                    filter_term: searchStr
                },
                successCallback: _this.getApproverContactsSuccessCallback,
                errorCallback: _this.errorCallback
            });
        }, DEFAULT_COLLAB_DEBOUNCE), _this.getMentionWithQuery = debounce(function (searchStr) {
            // Do not fetch without filter
            var _this$props8 = _this.props,
                file = _this$props8.file,
                api = _this$props8.api;

            if (!searchStr || searchStr.trim() === '') {
                return;
            }

            api.getFileCollaboratorsAPI(true).markerGet({
                id: file.id,
                limit: DEFAULT_MAX_COLLABORATORS,
                params: {
                    filter_term: searchStr
                },
                successCallback: _this.getMentionContactsSuccessCallback,
                errorCallback: _this.errorCallback
            });
        }, DEFAULT_COLLAB_DEBOUNCE), _this.fetchCurrentUserErrorCallback = function (e) {
            _this.setState({
                currentUser: undefined,
                currentUserError: {
                    maskError: {
                        errorHeader: messages.currentUserErrorHeaderMessage,
                        errorSubHeader: messages.defaultErrorMaskSubHeaderMessage
                    }
                }
            });
            _this.errorCallback(e);
        }, _this.getAvatarUrl = function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(userId) {
                var _this$props9, file, api;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this$props9 = _this.props, file = _this$props9.file, api = _this$props9.api;
                                return _context.abrupt('return', api.getUsersAPI(false).getAvatarUrlWithAccessToken(userId, file.id));

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref5.apply(this, arguments);
            };
        }(), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ActivitySidebar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var currentUser = this.props.currentUser;

            this.fetchFeedItems();
            this.fetchCurrentUser(currentUser);
        }
        /**
         * Fetches a Users info
         *
         * @private
         * @param {User} [user] - Box User. If missing, gets user that the current token was generated for.
         * @return {void}
         */

    }, {
        key: 'fetchCurrentUser',
        value: function fetchCurrentUser(user) {
            var shouldDestroy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var _props = this.props,
                api = _props.api,
                file = _props.file;


            if (!file) {
                throw getBadItemError();
            }

            if (typeof user === 'undefined') {
                api.getUsersAPI(shouldDestroy).get({
                    id: file.id,
                    successCallback: this.fetchCurrentUserSuccessCallback,
                    errorCallback: this.fetchCurrentUserErrorCallback
                });
            } else {
                this.setState({ currentUser: user, currentUserError: undefined });
            }
        }

        /**
         * Success callback for fetching feed items
         */


        /**
         * Error callback for fetching feed items
         */


        /**
         * Deletes a task via the API.
         *
         * @param {Object} args - A subset of the task
         */


        /**
         * Updates a task in the state via the API.
         *
         * @param {Object} args - A subset of the task
         * @return void
         */


        /**
         * Updates the task assignment
         *
         * @param {string} taskId - ID of task to be updated
         * @param {string} taskAssignmentId - Task assignment ID
         * @param {string} status - New task assignment status
         * @param {string} message - the message to the assignee
         * @return void
         */


        /**
         * Deletes a comment via the API.
         *
         * @param {Object} args - A subset of the comment
         * @return void
         */


        /**
         * Posts a new comment to the API
         *
         * @param {string} text - The comment's text
         * @param {boolean} hasMention - The comment's text
         * @return {void}
         */


        /**
         * Creates a task via the API
         *
         * @param {string} message - Task text
         * @param {Array} assignees - List of assignees
         * @param {number} dueAt - Task's due date
         * @return {void}
         */

    }, {
        key: 'fetchFeedItems',


        /**
         * Fetches the feed items for the sidebar
         *
         * @param {boolean} shouldDestroy true if the api factory should be destroyed
         */
        value: function fetchFeedItems() {
            var shouldDestroy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var _props2 = this.props,
                file = _props2.file,
                api = _props2.api;

            api.getFeedAPI(shouldDestroy).feedItems(file, this.fetchFeedItemsSuccessCallback, this.fetchFeedItemsErrorCallback);
        }

        /**
         * Handles a successful feed API fetch
         *
         * @private
         * @param {Array} feedItems - the feed items
         * @return {void}
         */


        /**
         * Handles a failed feed item fetch
         *
         * @private
         * @param {Error} e - API error
         * @return {void}
         */


        /**
         * Network error callback
         *
         * @private
         * @param {Error} error - Error object
         * @return {void}
         */


        /**
         * User fetch success callback
         *
         * @private
         * @param {Object} currentUser - User info object
         * @return {void}
         */


        /**
         * File approver contacts fetch success callback
         *
         * @private
         * @param {BoxItemCollection} collaborators - Collaborators response data
         * @return {void}
         */


        /**
         * File @mention contacts fetch success callback
         *
         * @private
         * @param {BoxItemCollection} collaborators - Collaborators response data
         * @return {void}
         */


        /**
         * File @mention contacts fetch success callback
         *
         * @private
         * @param {string} searchStr - Search string to filter file collaborators by
         * @return {void}
         */


        /**
         * File @mention contacts fetch success callback
         *
         * @private
         * @param {string} searchStr - Search string to filter file collaborators by
         * @return {void}
         */


        /**
         * Handles a failed file user info fetch
         *
         * @private
         * @param {Error} e - API error
         * @return {void}
         */


        /**
         * Gets the user avatar URL
         *
         * @param {string} userId the user id
         * @param {string} fileId the file id
         * @return the user avatar URL string for a given user with access token attached
         */

    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                file = _props3.file,
                _props3$isDisabled = _props3.isDisabled,
                isDisabled = _props3$isDisabled === undefined ? false : _props3$isDisabled,
                onVersionHistoryClick = _props3.onVersionHistoryClick,
                getUserProfileUrl = _props3.getUserProfileUrl;
            var _state = this.state,
                currentUser = _state.currentUser,
                approverSelectorContacts = _state.approverSelectorContacts,
                mentionSelectorContacts = _state.mentionSelectorContacts,
                feedItems = _state.feedItems,
                activityFeedError = _state.activityFeedError,
                currentUserError = _state.currentUserError;

            return React.createElement(
                SidebarContent,
                {
                    title: React.createElement(FormattedMessage, messages.sidebarActivityTitle)
                },
                React.createElement(ActivityFeed, {
                    file: file,
                    activityFeedError: activityFeedError,
                    approverSelectorContacts: approverSelectorContacts,
                    mentionSelectorContacts: mentionSelectorContacts,
                    currentUser: currentUser,
                    isDisabled: isDisabled,
                    onCommentCreate: this.createComment,
                    onCommentDelete: this.deleteComment,
                    onTaskCreate: this.createTask,
                    onTaskDelete: this.deleteTask,
                    onTaskUpdate: this.updateTask,
                    onTaskAssignmentUpdate: this.updateTaskAssignment,
                    getApproverWithQuery: this.getApproverWithQuery,
                    getMentionWithQuery: this.getMentionWithQuery,
                    onVersionHistoryClick: onVersionHistoryClick,
                    getAvatarUrl: this.getAvatarUrl,
                    getUserProfileUrl: getUserProfileUrl,
                    feedItems: feedItems,
                    currentUserError: currentUserError
                })
            );
        }
    }]);

    return ActivitySidebar;
}(React.PureComponent);

export { ActivitySidebar as ActivitySidebarComponent };
export default (function (props) {
    return React.createElement(
        APIContext.Consumer,
        null,
        function (api) {
            return React.createElement(ActivitySidebar, _extends({}, props, { api: api }));
        }
    );
});